import { Cartesian2, Cartesian3, Plane, createGuid } from "cesium";
import { EarthBrainUtils } from "../../utilities/earthbrainutility";
export class SlopePointInfo {
    id;
    position;
    probablePosition;
    isAbleToHit;
    treeHeight;
    isLeaf;
    up;
    down;
    front;
    back;
    crossSectionalplane;
    outwardDirection;
    isMerged;
    constructor(position, outwardDirection, treeHeight) {
        this.id = createGuid();
        this.position = position;
        this.probablePosition = position;
        this.outwardDirection = outwardDirection;
        this.treeHeight = treeHeight;
        this.up = [];
        this.down = [];
        this.isMerged = false;
        if (this.outwardDirection) {
            this.computeCrossSectionalplane();
        }
    }
    computeCrossSectionalplane() {
        const upDir = Cartesian3.UNIT_Z;
        const normal = Cartesian3.cross(this.outwardDirection, upDir, new Cartesian3());
        this.crossSectionalplane = Plane.fromPointNormal(this.position, normal);
    }
    isSibling(pointInfo) {
        const allDowns = this.up.flatMap((n) => n.down);
        return allDowns.includes(pointInfo);
    }
    computeOutwardDirection() {
        let incomingDir;
        let outGoingDir;
        if (this.back) {
            incomingDir = EarthBrainUtils.getDirBetweenTwoCartesians(this.back.probablePosition, this.probablePosition);
        }
        if (this.front) {
            outGoingDir = EarthBrainUtils.getDirBetweenTwoCartesians(this.probablePosition, this.front.probablePosition);
        }
        let resultantDir2D;
        if (incomingDir && outGoingDir) {
            resultantDir2D = Cartesian2.add(incomingDir, outGoingDir, new Cartesian2());
            Cartesian2.normalize(resultantDir2D, resultantDir2D);
        }
        else if (incomingDir) {
            resultantDir2D = incomingDir;
        }
        else {
            resultantDir2D = outGoingDir;
        }
        const resultantDir = new Cartesian3(resultantDir2D.x, resultantDir2D.y, 0);
        const tempUpDir = Cartesian3.cross(resultantDir, this.outwardDirection, new Cartesian3());
        const upDir = tempUpDir.z >= 0 ? new Cartesian3(0, 0, 1) : new Cartesian3(0, 0, -1);
        this.outwardDirection = Cartesian3.cross(upDir, resultantDir, new Cartesian3());
        Cartesian3.normalize(this.outwardDirection, this.outwardDirection);
        this.computeCrossSectionalplane();
    }
}
//# sourceMappingURL=slope-point-info.js.map